import React, { Component } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import Config from '../config/config';
import './NewsBox.css';
import faArrow from '@fortawesome/fontawesome-free-solid/faLongArrowAltRight';
import { toggleModal } from '../lib/util';

class HomeNewsBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalActive: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      modalActive: !this.state.modalActive,
    }, () => {
      toggleModal(this.state.modalActive);
    });
  }

  render() {
    const {
      date, title, content, image, newstype
    } = this.props.data;
    let truncatedContent = content || "";
    if (this.props.isShortNews && truncatedContent.length > 200) {
      truncatedContent = `${truncatedContent.slice(0, 197)}...`;
    }
    const dateObj = new Date(date);
    const dateStr = `${dateObj.getFullYear()}-${dateObj.getMonth()+1}-${dateObj.getDate()}`;
    
    const imageUrl = image && image.url ? `${Config.apiUrl}${image.url}` : null;

    return (
      <React.Fragment>
        <div
          className="box news-box"
        >
          <article className="media">
            <div className="media-left">
              <figure className={`image is-48x48 type-${newstype.name}`}>
                {imageUrl && <img className="image" src={imageUrl} alt={title} />}
              </figure>
            </div>
            <div className="media-content">
              <div className="content">
                <div className="content-header">
                <div className="content-header-date has-text-grey-light">{dateStr}</div>
                <div className="content-header-type">{newstype.title}</div>
              </div>
              <div className="content-header-title">{title}</div>
              </div>
            </div>
          </article>
          <div
            className="content-body"
            dangerouslySetInnerHTML={{ __html: marked(truncatedContent) }}
          />
          <div className="news-box-footer">
            <div 
              className="App-skew-more-button"
              role="button"
              onClick={this.toggleModal}
              onKeyUp={this.toggleModal}
            >
              <div>更多資訊</div>
              <FontAwesomeIcon className="news-box-footer-arrow" icon={faArrow}/>
            </div>
          </div>
        </div>

        <div className={this.state.modalActive ? 'modal news-modal is-active' : 'modal news-modal'}>
          <div
            className="modal-background"
            role="button"
            tabIndex={0}
            onClick={this.toggleModal}
            onKeyUp={this.toggleModal}
          />
          <div
            className="modal-content"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyUp={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="card">
              <button className="card-close" aria-label="close" onClick={this.toggleModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <div className="card-content">
                <div className="media">
                  {!imageUrl && <div className="media-left">
                    <figure className={`image is-48x48 type-${newstype.name}`}>
                    </figure>
                  </div>}
                  <div className="media-content">
                    <div className="content">
                      <div className="content-header">
                        <div className="content-header-date has-text-grey-light">{dateStr}</div>
                        <div className="content-header-type">{newstype.title}</div>
                      </div>
                      <div className="content-header-title">{title}</div>
                    </div>
                  </div>
                </div>
                <div className="card-content-body">
                  {imageUrl && <img src={imageUrl} alt={title} />}
                  <div className="content content-body" dangerouslySetInnerHTML={{ __html: marked(content || "") }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

HomeNewsBox.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  isShortNews: PropTypes.bool,
};

HomeNewsBox.defaultProps = {
  data: {
    date: new Date().toISOString(),
    type: 'news',
    title: 'Dummy title',
    content: 'Dummy content',
  },
  isShortNews: true,
};

export default HomeNewsBox;



// WEBPACK FOOTER //
// ./src/components/HomeNewsBox.js